import _ from 'lodash';

export const useCheckIsInMaxLength = (form, formParts) => (value, partId, elementName) => {
  // value = "Boris"; partId = "melderName"; elementName = "firstname"; formData = Formular, partData = Formparts
  const formDataSelected = form?.data.flatMap((pages) => pages.data).find((part) => part.id === partId);

  // Bei Files muss der State geprüft werden auf length und nicht das value.length

  // Maximale erlaubte Files/länge des Inputs in diesem Element prüfen
  if (formDataSelected?.config?.[elementName]?.maxLength) {
    if (formDataSelected?.config?.[elementName]?.maxLength < value.length) return false;
  } else if (formParts?.[formDataSelected.part].external.find((part) => part.id === elementName)?.config?.maxLength) {
    if (formParts?.[formDataSelected.part].external.find((part) => part.id === elementName)?.config?.maxLength < value.length) return false;
  }
  return true;
};

export const useCheckRequired = (form = {}, formParts = {}, activeStep, data = {}, onError, onSuccess) => (checkStep, nextClicked = false) => {
  // Variablen
  let allRequiredChecked = true;

  // Prüfen ob Data leer ist
  const isDataEmpty = Object.entries(data).length === 0 && data.constructor === Object;

  // Wenn activeStep übergeben wird werden nur die Elemente der Seite übergeben, sonst alle Elemente des gesamten Formulars
  const formData = (typeof activeStep === 'number' ? form?.data?.[activeStep]?.data : _.flatten(form?.data?.map((e) => e.data))) || [];

  // Liste aller Form-Elemente mit überlagerten Configs
  const formElements = _.flatten(
    formData.map((partData) =>
      formParts[partData.part]?.external.map((el) => {
        const newEl = structuredClone(el);
        const newData = _.merge(
					newEl,
					{ regex: partData?.regex },
					partData?.config || {},
					partData?.config?.external || {},
					_.isObject(partData?.config?.[el.id]) ? partData.config[el.id] : {},
					_.isObject(partData?.config?.[el.id]?.external) ? partData.config[el.id].external : {}
				);
        return {
          partId: partData.id,
          ...newData,
        };
      })
    )
  );

  // Alle Elemente mit required = true in der config
  const requiredElements = formElements.filter((e) => e?.required);

  // Pflichtfelder prüfen
  requiredElements.forEach(({ partId, id }) => {
    // Prüfen ob der Absendebutton nicht gedrückt wurde und Data leer ist.
    if (!nextClicked && checkStep !== activeStep && isDataEmpty) {
      allRequiredChecked = false;
      return onSuccess?.(partId, id);
    }

    // Prüfen ob der Absendebutton nicht gedrückt wurde und kein Wert für dieses Feld gesetzt ist
    if (!nextClicked && checkStep !== activeStep && (data?.[partId]?.[id] === '' || !data?.[partId]?.[id])) {
      allRequiredChecked = false;
      return onSuccess?.(partId, id);
    }

    // Prüfen ob Wert gesetzt ist
    if (data?.[partId]?.[id]) return onSuccess?.(partId, id);

    // Prüfen ob ein Feld ausgeblendet ist (unsichtbar) => dann kein Pflichtfeld mehr (Felder können per Javascript ausgeblendet werden)
    if (data?.[partId]?.display === false) return onSuccess?.(partId, id);

		// Falls nicht wird onError Funktion aufgerufen und die checkRequired Funktion liefert false zurück
    allRequiredChecked = false;
    onError?.(partId, id);
  });

  // Prüfungen der eingegebenen Daten - RegEx-Prüfung wenn vorhanden und nur wenn diese nicht leer sind!
  const RegExElements = formElements.filter((e) => e?.regex);
  RegExElements.forEach(({ partId, id, regex }) => {
		const regExPart = formElements.find(e => e.partId === partId && e.id === id);

		// Prüfen ob der Absendebutton nicht gedrückt wurde und Data leer ist.
		if (!nextClicked && checkStep !== activeStep && isDataEmpty) return onSuccess?.(partId, id);

		// Prüfen ob der Absendebutton nicht gedrückt wurde und kein Wert für das Feld gesetzt wurde.
		if (!nextClicked && checkStep !== activeStep && (data?.[partId]?.[id] === '' || !data?.[partId]?.[id])) return onSuccess?.(partId, id);

		if (!regExPart?.required && (data?.[partId]?.[id] === undefined || data?.[partId]?.[id] === '')) return onSuccess?.(partId, id);

    // Prüfen ob ein Feld ausgeblendet ist (unsichtbar) => dann kein Pflichtfeld mehr (Felder können per Javascript ausgeblendet werden)
    if (data?.[partId]?.display === false) return onSuccess?.(partId, id);
	
		// Prüfen ob Wert gesetzt ist
		if (data?.[partId]?.[id]?.match(regex)) return onSuccess?.(partId, id);

		// Wenn Regex nicht erfüllt dann false zurückgeben
		allRequiredChecked = false;
		onError?.(partId, id);
  });

  
  // Weiterbutton anzeigen & Weiter erlauben
  return allRequiredChecked;
};
